import { PageHead, Card, Pill } from "./_shared";

/**
 * Reusable placeholder page. Used by sections that don't have a fully-implemented
 * data model yet (Inbox, Opportunities, Contacts, …). Renders title, what this
 * section will control, related data sources, status, next action.
 */
export default function PlaceholderPage({
  testId,
  title,
  subtitle,
  willControl = [],
  relatedSources = [],
  status = "Planned for next phase",
  nextAction,
  comingNext = true,
  icon = null,
}) {
  return (
    <div data-testid={testId}>
      <PageHead
        title={title}
        sub={subtitle}
        right={comingNext ? <Pill tone="warn">Coming in next phase</Pill> : null}
      />

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        <Card title="What this section will control">
          {willControl.length === 0 ? (
            <Empty msg="Spec being finalized." />
          ) : (
            <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "grid", gap: 8 }}>
              {willControl.map((line, i) => (
                <li key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", fontSize: 13, color: "var(--pl-text)" }}>
                  <span style={{ width: 6, height: 6, borderRadius: 999, background: "var(--pl-aqua)", marginTop: 7, flexShrink: 0 }} />
                  <span>{line}</span>
                </li>
              ))}
            </ul>
          )}
        </Card>

        <Card title="Related data sources">
          {relatedSources.length === 0 ? (
            <Empty msg="No collections wired yet." />
          ) : (
            <div style={{ display: "grid", gap: 8 }}>
              {relatedSources.map((src, i) => (
                <div key={i} style={{
                  padding: "9px 11px", borderRadius: 10,
                  background: "var(--pl-bg-2)", border: "1px solid var(--pl-border)",
                  display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
                }}>
                  <span style={{ fontSize: 12, fontWeight: 700 }}>{src.label}</span>
                  <span style={{ fontFamily: "JetBrains Mono, monospace", fontSize: 11, color: "var(--pl-text-muted)" }}>{src.value}</span>
                </div>
              ))}
            </div>
          )}
        </Card>

        <Card title="Current status" style={{ gridColumn: "1 / -1" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <Pill tone="warn">Status</Pill>
              <span style={{ fontSize: 13, color: "var(--pl-text)" }}>{status}</span>
            </div>
            {nextAction && (
              <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <Pill tone="aqua">Next</Pill>
                <span style={{ fontSize: 13, color: "var(--pl-text)", lineHeight: 1.55 }}>{nextAction}</span>
              </div>
            )}
            {icon && (
              <div style={{ marginTop: 4, color: "var(--pl-text-muted)", fontSize: 11.5, lineHeight: 1.55, maxWidth: 720 }}>
                {icon}
              </div>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}

function Empty({ msg }) {
  return <div style={{ color: "var(--pl-text-muted)", fontSize: 12 }}>{msg}</div>;
}
